import { Component, ElementRef, EventEmitter, Input, NgModule, Output } from '@angular/core';

import { CommonModule } from '@angular/common';
import { toHeadingLevel, WHeadingLevel } from '@wipo/w-angular/shared';

@Component({
    selector: 'w-drawer',
    templateUrl: './w-drawer.component.html',
    host: {
        'class': 'b-drawer',
        '[class.b-drawer--is-popover]': "isPopup",
        '[class.b-workbench-filter-advanced]': "isFilter"
    },
    standalone: false
})
/*
@id w-drawer
@name w-drawer
@status release
@description optional section
*/
export class WDrawerComponent {
  @Input() isPopup = false;   // show as popup
  @Input('close-button') _close_old?: string; // @no-doc (deprecate) show close icon/button; applies only in popup, switch to unified w- attribute prefix
  @Input('w-close-button') _close?: string; // show close icon/button; applies only in popup
  get hasCloseButton(){
    return this.isPopup && (this._close_old !== undefined || this._close !== undefined);
  }
  @Input() isFilter = false;  // displayed in w-filter component
  @Input() title: string = '';
  @Input() headingLevel: WHeadingLevel = 4; // title heading level 1-6 or 'h1'-'h6'
  @Output() wClose = new EventEmitter<void>();
  constructor(public elRef: ElementRef<HTMLElement>){}
  get level() {
    return toHeadingLevel(this.headingLevel, 4);
  }
}
@NgModule({
  imports: [CommonModule],
  exports: [WDrawerComponent],
  declarations: [WDrawerComponent]
})
export class WDrawerModule { }
